import { Variables } from "./Variables";
import triggerIcon from "../../../../new-images/profile/trigger-icon.svg";
import { REJECT_REASONS } from "../../../../entities/reject_reason";

export const useRejectedDonationVariables = (reason) => {

  return new Variables(
    {
      title: `У вас есть отклоненная донация`,
      img: triggerIcon,
      prompt: (
        <span>Нам нужно знать точное количество и даты донаций, чтобы выстраивать честную коммуникацию с донорами.<br/><br/>Доступный вариант верификации числа донаций - это справки по формам 402 (дается в день сдачи крови) или 405 и 448, где указано общее число донаций. Их можно взять в центре крови, где вы совершали донации.<br/><br/>ИЛИ<br/><br/>можно на сайте Госуслуги увидеть все донации - <a href="https://www.gosuslugi.ru/donation" target="_blank">https://www.gosuslugi.ru/donation</a> Принимаем скриншоты из сайта госуслуг, перейдите в КАЖДУЮ донацию (нажмите на "справка" в госуслугах) и сделайте скрин экрана, где указано ФИО ДОНОРА, место сдачи, дата и тип донации. Пример - <a href="https://disk.yandex.ru/i/OWD3NiRuRFf6tg" target="_blank">https://disk.yandex.ru/i/OWD3NiRuRFf6tg</a><br/>Каждый скрин будет подтверждать соответствующую донацию в личном кабинете донора на <a href="/profile/add_donation" target="_blank">https://donorsearch.org/profile/add_donation</a></span>
      ),
      label: REJECT_REASONS[reason]?.text || "Чтобы подтвердить донацию, приложите к ней фото справки из центра крови или скриншот из госуслуг.",
      button: "Перейти к донации",
    },
  )
};
